import { useEffect } from "react";
import { VendorReviews } from "@/components/VendorReviews";
import { api } from "@/lib/api";
import { refreshUnread } from "@/lib/useUnread";

export default function VendorReviewsPage() {
  useEffect(() => { api.post("/notifications/read", { kind: "business" }).then(refreshUnread).catch(() => {}); }, []);
  return (
    <main data-testid="vendor-reviews-page" className="max-w-3xl mx-auto px-4 sm:px-6 py-4">
      <VendorReviews />
    </main>
  );
}
